export default __webpack_public_path__ + "static/media/calendar.8baa491a.svg";